<div class="card my-3" *ngIf="event">
  <div class="card-header text-white bg-primary text-center sticky-title">
    Trajet
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-xl-6 col-lg-8 col-sm-12 py-1">
        <label for="adresseDepart">Adresse Départ</label>
        <textarea
          rows="3"
          id="adresseDepart"
          class="form-control"
          [(ngModel)]="event.adresseDepart"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!editable"
          (input)="onFieldChange()"
        ></textarea>
      </div>

      <div class="col-xl-6 col-lg-8 col-sm-12 py-1">
        <label for="adresseArrivee">Adresse Arrivée</label>
        <textarea
          rows="3"
          id="adresseArrivee"
          class="form-control"
          [(ngModel)]="event.adresseArrivee"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!editable"
          (input)="onFieldChange()"
        ></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-4 offset-xl-4 col-lg-4 col-sm-12 py-1 text-center">
        <button
          type="button"
          class="btn btn-success"
          [disabled]="!editable"
          (click)="computeTrajet()">
          <i class="fa-solid fa-route"></i> Calculer Trajet
        </button>
      </div>

      <div class="col-xl-4 col-lg-4 col-sm-12 py-1 text-end">
        <button
          type="button"
          class="btn btn-info me-2"
          (click)="goGoogleMaps()">
          <i class="fa-solid fa-map-location"></i> Google
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="goWaze()">
          Waze
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-3 offset-xl-3 col-lg-4 col-sm-12 py-1">
        <label for="distanceKm">Distance Km (calculée)</label>
        <input
          disabled
          id="distanceKm"
          type="text"
          class="form-control"
          [value]="event.distanceKm"
        />
      </div>

      <div class="col-xl-3 col-lg-4 col-sm-12 py-1">
        <label for="dureeMinutes">Durée Trajet (calculée)</label>
        <input
          disabled
          id="dureeMinutes"
          type="text"
          class="form-control"
          [value]="formatDuration(event.dureeMinutes)"
        />
      </div>
    </div>
  </div>
</div>
